<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="buzon.caja_fecha"
              label="Fecha"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="buzon.usuario_iniciales"
              label="Usuario"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="buzon.turno"
              label="Turno"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="buzon.registro"
              label="Registro"
              type="number"
              required
              readonly="true"
            ></v-text-field>
            <!-- :readonly="!isNewRecord" -->
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="buzon.importe"
              id="importe"
              label="Importe"
              type="number"
              step="0.01"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="buzon.detalle"
              label="Detalle"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ id < 1 ? 'Crear' : 'Actualizar' }} buzón
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <BaseModal
        v-model="showModal"
        :title="modalConfig.title"
        :message="modalConfig.message"
        :type="modalConfig.type"
        :button-text="modalConfig.buttonText"
      />
    </v-form>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import {
  focusFirstInput,
  formatDate,
  processImporte,
  userIsRecepcion
} from '@/utils/helpers'
import { useBuzonesStore } from '@/stores/buzonesStore'
import { getUser } from '@/utils/tokenStorage'
import NoPermission from '@/components/common/NoPermission.vue'
import BaseModal from '../common/BaseModal.vue'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})

// Estado del modal
const showModal = ref(false)
const modalConfig = reactive({
  title: '',
  message: '',
  type: 'info',
  buttonText: 'Aceptar'
})

const buzonesStore = useBuzonesStore()
const userIsRecepcionValue = userIsRecepcion()
const loading = ref(false)
const emit = defineEmits(['saved'])

const buzon = reactive({
  id: null,
  turno: '',
  hotel: '',
  caja_id: '',
  usuario_id: '',
  caja_fecha: '',
  usuario_iniciales: '',
  registro: null,
  importe: 0,
  detalle: ''
})

const isNewRecord = computed(() => !props.id)

onMounted(async () => {
  const userInfo = getUser()
  buzon.usuario = userInfo.usuario
  buzon.usuario_id = userInfo.usuario_id
  buzon.turno = userInfo.turno
  const data = await buzonesStore.getBuzon(props.id)
  buzon.registro = data.registro

  if (props.id) {
    loading.value = true
    try {
      Object.assign(buzon, data)
      buzon.caja_id = data.caja_id || null
      buzon.caja_fecha = formatDate(data.caja_fecha) || ''
    } catch (error) {
      console.error('Error al cargar el buzón:', error)
    } finally {
      loading.value = false
    }
  }
  // Add focus to first enabled input after form is loaded
  focusFirstInput()
})

const submitForm = async () => {
  // si importe es 0, no se puede crear la tarjeta, mostrar modal de error
  buzon.importe = processImporte(buzon.importe)

  loading.value = true
  try {
    if (buzon.id) {
      await buzonesStore.updateBuzon(buzon)
    } else {
      await buzonesStore.createBuzon({ ...buzon })
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar el buzón:', error)
  } finally {
    loading.value = false
  }
}
defineExpose({
  buzon,
  loading,
  // usuarios,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})
</script>
